import { render, staticRenderFns } from "./AccountingLedger.vue?vue&type=template&id=1240d01d&scoped=true"
import script from "./AccountingLedger.vue?vue&type=script&lang=js"
export * from "./AccountingLedger.vue?vue&type=script&lang=js"
import style0 from "./AccountingLedger.vue?vue&type=style&index=0&id=1240d01d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240d01d",
  null
  
)

export default component.exports